var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeViewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4833 10.4999C13.4833 12.1499 12.1499 13.4833 10.4999 13.4833C8.84993 13.4833 7.5166 12.1499 7.5166 10.4999C7.5166 8.84993 8.84993 7.5166 10.4999 7.5166C12.1499 7.5166 13.4833 8.84993 13.4833 10.4999Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 17.3913C13.4418 17.3913 16.1834 15.6579 18.0918 12.6579C18.8418 11.4829 18.8418 9.50794 18.0918 8.33294C16.1834 5.33294 13.4418 3.59961 10.5001 3.59961C7.55845 3.59961 4.81678 5.33294 2.90845 8.33294C2.15845 9.50794 2.15845 11.4829 2.90845 12.6579C4.81678 15.6579 7.55845 17.3913 10.5001 17.3913Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeViewIcon);
export default __webpack_public_path__ + "static/media/eye_view_icon.ebec7c7ecfe4aa752885954b8619ab32.svg";
export { ForwardRef as ReactComponent };